import React, { useState, useEffect,useLayoutEffect ,useRef} from "react";
//import {createRoot} from "react-dom/client";
import "./Video.scss";
const Video =(props) =>{
    const [videoItem,setVideoItem] = useState(null);
    const [startPlay,setStartPlay] = useState(false);
    const youTubeIframe = useRef();
    
    useEffect(()=>{
        if(startPlay){
        //    youTubeIframe.setVolume(25);
        }
    },[startPlay]);
   
    useEffect(()=>{
        if(!!props.items && props.items.length>0){
            setVideoItem(props.items[0]);
        }
    },[props.items]);
    const StartPlayFun=()=>{
        setStartPlay(true);
    };
    return (<div className='container-video-warpper col-12 col-md-8 nav-section' id={`nav-section-2`}>
        {/* <div className={"video-title col-11 col-md-12 "}>{props.title}</div> */}
        {!!videoItem && <div className={"video-title col-11 col-md-12 "}>{ videoItem.LinkTitle }</div>}

      {!!videoItem &&  <div className={"video-warpper col-11 col-md-12"}>   
     { !startPlay ? <div className={"video-img col-12"}
                         style={{backgroundImage:`url(${videoItem.MashanTopMobileImage.ImageUrl}?RenditionID=17`,backgroundSize:'cover'}}
      >

             <div className={'play-arrow'} onClick={StartPlayFun}><div className='inner-arrow'></div></div> 
        </div> : !!videoItem.MashanContainerLink &&
        <iframe ref={youTubeIframe} src={videoItem.MashanContainerLink.NavigateUrl+'&autoplay=1'} title={videoItem.LinkTitle} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypt-media; gyroscope;"
         referrerPolicy="strict-origin-when-cross-origin" 
        allowFullScreen></iframe>

            }
        {/* <span className="border-btm"></span> */}
        </div>
        }
         
    </div>)
};
export default Video;